module.exports = __webpack_public_path__ + "img/6.12109df6.jpg";